import { EffectIndex, KK, VK } from '@/define/define'
import { BaseDevice, CustomLayout, Dpi, initDpiColor, initDpiList } from '../base_device'
import icon from '@/assets/img/device/he2/he2_bg.png'
import board from '@/assets/img/device/he2/HE2.png'
import { mouseVKCodes_c } from '../keyboard/keycode/vkeycode'
import { DeviceType } from '@libs/types/enum'
import { LightEffectMode, LightEffectModeType } from '@/define/light'

export class He2 extends BaseDevice {
  name: string = 'HE2'
  icon: string = icon
  boardImage: string = board
  width: number = 209
  paddingX: number = 0
  paddingY: number = 0
  paddingBottom: number = 0
  texture = {}
  deviceType = DeviceType.mouse
  resetDes = ''
  // 不可操作
  inoperableKeys: KK[] = [0x0]
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = {
    [LightEffectMode.Static_2]: 1,
    [LightEffectMode.Breathing_2]: 2,
    [LightEffectMode.RainbowWaterfall]: 3,
  }
  vkcodes = mouseVKCodes_c

  absoluteKey: CustomLayout = {
    0x01: this.createSquare(122, 0, 74, 193),
    0x02: this.createSquare(89, 42, 33, 66),
    0x04: this.createSquare(5, 122, 13, 59),
    0x03: this.createSquare(7, 176, 15, 59),
    0x05: this.createSquare(93, 136, 22, 32),
  }
  mouseClass: { [index: KK]: string } = {
    0x01: 'right',
    0x02: 'middle',
    0x04: 'forward',
    0x03: 'back',
    0x05: 'dpi',
  }
  speedAllowValues = [5, 4, 3, 2, 1]
  lightAllowValues = [0, 1, 2, 3, 4]
  dpi: Dpi = {
    initList: initDpiList(),
    initListColor: initDpiColor(),
    length: 7,
    list: [
      200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000, 3100, 3200, 3300, 3400, 3500, 3600, 3700, 3800, 3900, 4000, 4100, 4200, 4300, 4400,
      4500, 4600, 4700, 4800, 4900, 5000, 5100, 5200, 5300, 5400, 5500, 5600, 5700, 5800, 5900, 6000, 6100, 6200, 6500, 7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500, 12000, 12400,
    ],
    des: 'dpi_notice',
    isEdit: true,
    isColor: true,
  }
  rate: number[] = [0.125, 0.25, 0.5, 1]
}
